import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNumericScreenSize } from "~/common/hooks/useNumericScreenSize";
import { selectSearchDisplayMode, selectIsUseNewDesign } from "~/domains/userPreferences/redux/selectors";
import { changeDisplayModeThunk } from "~/domains/userPreferences/redux/userPreferencesSlice";
import { SearchDisplayMode } from "../../models/models";

// Minimum screen size for technical view to be visible
const MINIMUM_SCREEN_SIZE = useNumericScreenSize.desktopS;

export const useSRPResultsViewMode = () => {
  let displayMode = useSelector(selectSearchDisplayMode);
  const useNewDesign = useSelector(selectIsUseNewDesign);

  const dispatch = useDispatch();
  const setDisplayMode = useCallback((mode: SearchDisplayMode) => dispatch(changeDisplayModeThunk(mode)), []);

  const screenSize = useNumericScreenSize();
  let isTechnicalViewVisible = true;

  if (useNewDesign && screenSize < MINIMUM_SCREEN_SIZE) {
    isTechnicalViewVisible = false;
  }

  // If tabular view is selected and the screen size is too small, switch to list view,
  // but preserve the user selection in state in case the user changes the screen size later
  if (displayMode === SearchDisplayMode.TABULAR && useNewDesign && screenSize < MINIMUM_SCREEN_SIZE) {
    displayMode = SearchDisplayMode.LIST;
  }

  return [displayMode, setDisplayMode, isTechnicalViewVisible] as const;
};
